import Component from '../../shared/component';

const ROTATION_INTERVAL = 5000;

export default class PartnersRotator extends Component {
  constructor(element) {
    super(...arguments);

    this.$element = $(element);
    this.originalElementHeight = this.$element.height();

    this.$partners = this.$element.find('.partners-logos');
    this.$innerElement = this.$element.find('.partners-logos-inner');
    this.previousIndex = null;
    this.index = 0;

    this.initialize();
    this.bindTimeout();
    this.bindEvents();
  }

  bindEvents() {
    this.handleMouseEnter = this.handleMouseEnter.bind(this);
    this.handleMouseLeave = this.handleMouseLeave.bind(this);

    this.$innerElement.on('mouseenter.PartnersRotator', this.handleMouseEnter);
    this.$innerElement.on('mouseleave.PartnersRotator', this.handleMouseLeave);
  }

  unbindEvents() {
    this.$innerElement.off('mouseenter.PartnersRotator', this.handleMouseEnter);
    this.$innerElement.off('mouseleave.PartnersRotator', this.handleMouseLeave);

    this.unbindTimeout();
  }

  bindTimeout() {
    this.unbindTimeout();

    this.timeout = setTimeout(() => {
      if (this.timeout) {
        this.showNextPartners();
      }
    }, ROTATION_INTERVAL);
  }

  unbindTimeout() {
    clearTimeout(this.timeout);
    this.timeout = null;
  }

  initialize() {
    this.$partners.hide();
    this.$partners.eq(0).show();
  }

  showNextPartners() {
    this.previousIndex = this.index;
    if (this.index >= this.$partners.length - 1) {
      this.index = 0;
    } else {
      this.index += 1;
    }

    this.hidePartners();
  }

  hidePartners() {
    if (this.previousIndex !== null) {
      this.$partners
        .eq(this.previousIndex)
        .fadeOut('slow', () => this.showPartners());
    } else {
      this.showPartners();
    }
  }

  showPartners() {
    this.$partners.eq(this.index).fadeIn('slow', () => this.bindTimeout());
  }

  handleMouseEnter() {
    this.unbindTimeout();
  }

  handleMouseLeave() {
    if (this.timeout == null) {
      this.bindTimeout();
    }
  }
}
